export default __webpack_public_path__ + "static/note-wave-eee462c343ee70f86c9b080305a7953b.mp4";